const MEDIA_QUERIES = {
	MOBILE_PORTRAIT: 375,
	MOBILE_LANDSCAPE: 767,
	TABLET: 1024,
	DESKTOP: 1276,
};
export default MEDIA_QUERIES;
